import React from 'react';
import ReactApexChart from 'react-apexcharts';

import { ApexOptions } from 'apexcharts';
import { NewFormatValue } from '../../../../utils/NewFormatValue';
import { ContentChart } from './styles';
import { initialCategories, initialSeries } from './data';

import theme from '../../../../styles/themes/default';

interface BarProps {
  categories?: string[];
  dataValue: number[];
  isLoading?: boolean;
}

export const BarChart = ({ categories, dataValue, isLoading }: BarProps) => {
  //const isLoading = dataValue ? false : true;

  const options: ApexOptions = {
    chart: {
      id: 'bar',
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
      },
      toolbar: {
        tools: {
          download: true,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false,
        },
      },
    },
    colors: ['#F58025'],
    xaxis: {
      categories: isLoading ? initialCategories : categories,
    },
    yaxis: {
      tickAmount: 6,
      labels: {
        formatter: (value) =>
          new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            maximumFractionDigits: 0,
          }).format(value),
      },
    },
    tooltip: {
      y: { formatter: (value) => NewFormatValue(Number(value)) },
      shared: true,
      intersect: false,
    },
    title: {
      text: isLoading ? 'Carregando ...' : 'Saldo a Receber',
      align: 'center',
      style: {
        fontWeight: 500,
        fontSize: '16px',
      },
    },
    dataLabels: {
      enabled: true,
      offsetY: -14,
      style: {
        fontSize: '0.65rem',
        fontWeight: 500,
        colors: [theme.colors.gray[600]],
      },
      formatter: (value) => NewFormatValue(Number(value)),
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        borderRadiusApplication: 'end',
        horizontal: false,
        dataLabels: {
          hideOverflowingLabels: false,
          position: 'top',
        },
      },
    },
  };

  const series = [
    {
      name: 'Valor total',
      data: isLoading ? initialSeries : dataValue,
    },
  ];

  return (
    <ContentChart>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={250}
      />
    </ContentChart>
  );
};
